function UrgencySection() {
  return null;
}

export default UrgencySection;
